function getValueSelected(node: HTMLSelectElement): string {
  return node.options[node.selectedIndex] ? node.options[node.selectedIndex].value : ''
}

export default getValueSelected
